/**
 * 该文件为脚本自动生成文件，请勿随意修改。如需修改请联系 PMC
 * */

import { TdOptionGroupProps, TdOptionProps, TdSelectProps } from './type';

export const selectDefaultProps: TdSelectProps = {
  autoWidth: false,
  autofocus: false,
  borderless: false,
  clearable: false,
  creatable: false,
  loading: false,
  max: 0,
  minCollapsedNum: 0,
  multiple: false,
  placeholder: undefined,
  readonly: false,
  reserveKeyword: false,
  showArrow: true,
  size: 'medium',
  status: 'default',
  valueType: 'value',
};

export const optionDefaultProps: TdOptionProps = { checkAll: false, disabled: false };

export const optionGroupDefaultProps: TdOptionGroupProps = { divider: true };
